const CLOSING_TYPE = 'closing'
const OPENING_TYPE = 'opening'

// Used on closing. Do not let an item close if it is the last item.
const ensureOneOpenedOnClose = (state, upcomingChanges) => {
  if (
    upcomingChanges.type === CLOSING_TYPE &&
    upcomingChanges.openIndices.length > 2
  ) {
    return { ...upcomingChanges, openIndices: state.openIndices }
  }
  return upcomingChanges
}

// Used on opening. Have one item opened.
const onlyOneOpenedOnOpen = (state, upcomingChanges) => {
  if (upcomingChanges.type === OPENING_TYPE) {
    return { openIndices: upcomingChanges.openIndices.slice(-1) }
  }

  return upcomingChanges
}

const combineReducers = (...reducers) => {
  return (state, upcomingChanges) => {
    for (const reducer of reducers) {
      const result = reducer(state, upcomingChanges)
      if (result !== upcomingChanges) {
        return result
      }
    }
    return upcomingChanges
  }
}

export { ensureOneOpenedOnClose, onlyOneOpenedOnOpen, combineReducers }
